import api from '../../api/api';
import {GET_FAQ} from '../actionTypes';
import {UPDATE_FAQ} from '../mutationTypes';

export default {
  [GET_FAQ]: async ({commit}) => {
    commit(UPDATE_FAQ, await api.faqApi.get_faq().then(({data}) => data));
  },
};
